import intl from 'react-intl-universal';
import { getIssuePriority } from 'shared/constants/issues';
import { formatDateTime } from 'utils/formatTime';
import { generateUserFullName } from 'utils/name';
import logger from 'utils/logger';
import { checkUndefinedOrNull } from 'utils/misc';

const log = logger.createLogger('CSV Content');

const getWagesCSVHeader = (isPaidWage, isKenshin) => {
  return isKenshin
    ? [
        isPaidWage
          ? intl.get('wages_csv_label_column_doctor')
          : intl.get('wages_csv_label_column_organization'),
        intl.get('wages_csv_label_column_case_id'),
        intl.get('wages_csv_label_column_created_at'),
        intl.get('wages_csv_label_column_done_at'),
        intl.get('wages_csv_label_column_original_wage'),
        intl.get('wages_csv_label_column_current_wage'),
        intl.get('wages_csv_label_column_remark'),
      ]
    : [
        isPaidWage
          ? intl.get('wages_csv_label_column_doctor')
          : intl.get('wages_csv_label_column_organization'),
        intl.get('wages_csv_label_column_patient_id'),
        intl.get('wages_csv_label_column_issue_id'),
        intl.get('wages_csv_label_column_emergency'),
        intl.get('wages_csv_label_column_tag'),
        intl.get('wages_csv_label_column_created_at'),
        intl.get('wages_csv_label_column_done_at'),
        intl.get('wages_csv_label_column_original_wage'),
        intl.get('wages_csv_label_column_current_wage'),
        intl.get('wages_csv_label_column_remark'),
      ];
};

const WAGES_CHANGE_HISTORY_TYPE = {
  DEFAULT: 'default',
  ADJUST: 'adjust',
};

export const createWagesCSVContent = (data, isPaidWage) => {
  const header = getWagesCSVHeader(isPaidWage, false);
  const csvContent =
    'data:text/csv;charset=utf-8,' +
    '\uFEFF' +
    header.join(',') +
    '\n' +
    data
      .map((wage) => {
        const firstColumn = isPaidWage
          ? generateUserFullName(wage.user.firstName, wage.user.lastName)
          : wage.organization.name;

        const issueTitle = wage.issueTitle;
        const emergencyText = getIssuePriority(wage.issuePriority);
        const checkItems = wage.issueCheckItems?.join(';');
        const createdAt = formatDateTime(wage.issueCreatedAt);
        const doneAt = formatDateTime(wage.createdAt);
        const originalWage = wage.originalWage;
        const currentWage =
          wage.currentWage === null ? wage.originalWage : wage.currentWage;
        // generate remark
        let remarks = '';
        let changeHistory = JSON.parse(wage.changeHistory);
        if (changeHistory === null) changeHistory = [];
        changeHistory.forEach((history) => {
          const historyType = history.type;
          if (historyType === WAGES_CHANGE_HISTORY_TYPE.ADJUST) {
            const remark = `${intl.get(
              'wages_csv_label_column_wage_adjustment'
            )} ${history.wageChange || 0};`;
            remarks += remark;
          }
        });

        const tagLabels = checkItems ? checkItems.replace(/,/g, ' ') : '';
        const patientName = checkUndefinedOrNull(
          wage.issue ? wage.issue.patientName : ''
        );

        const remarks_ = remarks.replace(/,/g, ' ');
        return (
          firstColumn +
          ',' +
          patientName +
          ',' +
          issueTitle +
          ',' +
          emergencyText +
          ',' +
          tagLabels +
          ',' +
          createdAt +
          ',' +
          doneAt +
          ',' +
          originalWage +
          ',' +
          currentWage +
          ',' +
          remarks_
        );
      })
      .join('\n');
  return csvContent;
};

export const createCSVKenshinCSVContent = (data, isPaidWage, doctorName) => {
  // TODO Needs the doctor name
  const header = getWagesCSVHeader(isPaidWage, true);
  const csvContent =
    'data:text/csv;charset=utf-8,' +
    '\uFEFF' +
    header.join(',') +
    '\n' +
    data
      .map((wage) => {
        const firstColumn = isPaidWage ? doctorName : wage.orgName;
        const caseIdentifierId = wage.caseIdentifierId;
        const createdAt = formatDateTime(wage.caseCreatedAt);
        const doneAt = formatDateTime(wage.createdAt); //! The wage is created when the task is done
        const originalWage = wage.originalWage;
        const currentWage =
          wage.currentWage === null ? wage.originalWage : wage.currentWage;
        // generate remark
        let remarks = '';
        let changeHistory = JSON.parse(wage.changeHistory);
        if (changeHistory === null) changeHistory = [];
        changeHistory.forEach((history) => {
          const historyType = history.type;
          if (historyType === WAGES_CHANGE_HISTORY_TYPE.ADJUST) {
            const remark = `${intl.get(
              'wages_csv_label_column_wage_adjustment'
            )} ${history.wageChange};`;
            remarks += remark;
          }
        });

        const remarks_ = remarks.replace(/,/g, ' ');
        return (
          firstColumn +
          ',' +
          caseIdentifierId +
          ',' +
          createdAt +
          ',' +
          doneAt +
          ',' +
          originalWage +
          ',' +
          currentWage +
          ',' +
          remarks_
        );
      })
      .join('\n');

  return csvContent;
};

export const createDownloadLink = (csvContent, filename) => {
  const encodeUri = encodeURI(csvContent);
  const link = document.createElement('a');
  link.setAttribute('href', encodeUri);
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
